import { render, staticRenderFns } from "./RelationOrderInfo.vue?vue&type=template&id=41452d09"
import script from "./RelationOrderInfo.vue?vue&type=script&lang=js"
export * from "./RelationOrderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports